<form ngForm #logForm="ngForm" autocomplete="off">
    <div class="d-flex justify-content-between">
        <div *ngIf="newLogPost" class="h3 my-2">New Log Entry</div>
        <div *ngIf="!newLogPost" class="h3 my-2">{{managerLogPostSelected.subject}}</div>
        <div class="ms-auto">
            <p-button *ngIf="newLogPost" pRipple styleClass="p-button-raised m-2" [disabled]="logForm.invalid" (click)="savePost()">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","save"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
            <p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="clearEmitter.emit(true);">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","times-circle"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
        </div>
    
    </div>
    
    <div *ngIf="newLogPost" class="d-flex flex-column">
        <div class="d-flex flex-row">
            <span class="p-float-label mt-3 mx-2">
                <p-calendar required required styleClass="w-100 my-2" [maxDate]="maxDate"
                    [(ngModel)]="managerLogPostSelected.businessDate" id="businessDate" name="businessDate" (onInput)="salesSummaryGet($event)" (onSelect)="salesSummaryGet($event)"></p-calendar>
                <label for="businessDate" class="mx-2">Business Date</label>
            </span>
            <div class="flex-grow-1">
                <span class="p-float-label mt-3 ms-2 me-4 w-100">
                    <input pInputText required [disabled]="!newLogPost" type="text" name="subject" id="subject"
                        [(ngModel)]="managerLogPostSelected.subject" class="w-100 my-2 me-4" />
                    <label for="subject" class="mx-2">Log Subject</label>
                </span>
            </div>
        </div>

        <app-log-view-sales-summary *ngIf="managerLogPostSelected.salesSummary"
            [salesSummary]="managerLogPostSelected.salesSummary" [createdDate]="moment().format()"></app-log-view-sales-summary>

        <div class="mt-3 m-2">
            <p-chips [(ngModel)]="managerLogPostSelected.tags" placeholder="Log Post Tags" class="p-fluid m-2"
                id="postTags" name="postTags"></p-chips>
        </div>
    
        <p-editor required [(ngModel)]="managerLogPostSelected.body"  name="logBody" id="logBody"  styleClass="w-100 my-4 mx-2">
            <p-header>
                <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                </span>
            </p-header>
        </p-editor>
        <div class="h4">
            Notify:
        </div>
        <div class="d-flex flex-row">
            <div *ngFor="let user of venueUserList">
                <div class="mx-4">
                    <p-checkbox name="notify{{user.key}}" [value]="user.key" [(ngModel)]="managerLogPostSelected.notifications"  labelStyleClass="mt-2" styleClass="ms-4"></p-checkbox>
                    {{user.firstName}} {{user.lastName}} ({{user.email}})
                </div>
                
            </div>
        </div>
    </div>

    <div *ngIf="!newLogPost" class="d-flex flex-column">
        <div class="d-flex flex-row">
            <div class="m-2">Business Date: {{moment(managerLogPostSelected.businessDate).format('l')}}</div>
            <div class="my-2 me-2 ms-4">By: {{managerLogPostSelected.authorUser.firstName}} {{managerLogPostSelected.authorUser.lastName}}</div>
        </div>

        <app-log-view-sales-summary *ngIf="managerLogPostSelected.salesSummary"
            [salesSummary]="managerLogPostSelected.salesSummary" [createdDate]="moment().format()"></app-log-view-sales-summary>

        <div class="mt-3 ms-2 d-flex flex-row">
            <div *ngFor="let tag of managerLogPostSelected.tags">
                <p-chip [label]="tag" styleClass="p-me-2 custom-chip"></p-chip>
            </div>
        </div>

        <p-scrollPanel [style]="{width: '100%', height: '200px'}" styleClass="p-scrollpanel custombar1">
            <div class="m-2" [innerHTML]="managerLogPostSelected.body"></div>
        </p-scrollPanel>

        <div *ngIf="commentsLoaded" class="mt-3">
            <p-divider align="center">Comments</p-divider>
            <app-log-comment *ngIf="managerLogPostSelected && currentUser" [managerLogPostSelected]="managerLogPostSelected">
            </app-log-comment>
            <app-log-comment-create *ngIf="managerLogPostSelected && currentUser" [managerLogPostSelected]="managerLogPostSelected"
                [currentUser]="currentUser" (commentEmitter)="newCommentReturn($event)"></app-log-comment-create>
        </div>
        <div *ngIf="!commentsLoaded" class="d-flex justify-content-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
        
    </div>

</form>